import React, { useState, useEffect, useRef } from "react";
import "../styles/Clause.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faCopy } from "@fortawesome/free-solid-svg-icons";
import CopyToClipboard from "react-copy-to-clipboard";

export default function Clause({ Clause }) {
  const [isHotSpotOpen, setisHotSpotOpen] = useState(false);

  const handleHotSpotCard = (e) => {
    setisHotSpotOpen(!isHotSpotOpen);
  };

  let buttonRef = useRef();

  useEffect(() => {
    let handler = (e) => {
      if (isHotSpotOpen === true && !buttonRef.current.contains(e.target)) {
        setisHotSpotOpen(false);
      }
      if (isHotSpotOpen === false) {
        setTextColor("#1d3a8a");
        setCopyClause("Copy Clause");
      }
    };

    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [isHotSpotOpen]);

  const [copyClause, setCopyClause] = useState("Copy Clause");
  const [TextColor, setTextColor] = useState("#1d3a8a");

  const setCopied = (e) => {
    setTextColor("#00ad43");
    setCopyClause("Copied");
  };

  return (
    <div className="w-full min-w-0 max-w-full">
      <div
        className={`relative w-full min-w-0 max-w-full${isHotSpotOpen ? " clause-hotspot-anchor" : ""}`}
        ref={buttonRef}
      >
        {isHotSpotOpen === true ? (
          <div className="flex items-center clause-row">
            <FontAwesomeIcon
              icon={faMinus}
              color="#cc0000"
              onClick={handleHotSpotCard}
              className="clause-icon-minus"
            />
            <div className="flex items-center pl-2 clause-font">
              {Clause.title}
            </div>
          </div>
        ) : (
          <div className="flex items-center clause-row">
            <FontAwesomeIcon
              icon={faPlus}
              color="#1b489b"
              onClick={handleHotSpotCard}
              className="clause-icon-plus"
            />
            <div className="flex items-center pl-2 clause-font">
              {Clause.title}
            </div>
          </div>
        )}

        <div className="clause-popup-slot">
          {isHotSpotOpen === true ? (
            <>
              <div className="absolute button-window ">
                <div
                  dangerouslySetInnerHTML={{
                    __html: Clause.notes,
                  }}
                />
                {Clause.text.length === 0 ? (
                  ""
                ) : (
                  <>
                    {" "}
                    <br />
                    <strong>Clause:</strong>
                    <br />
                  </>
                )}

                <div
                  dangerouslySetInnerHTML={{
                    __html: Clause.text,
                  }}
                />
                <br />
                {Clause.text.length === 0 ? (
                  ""
                ) : (
                  <CopyToClipboard
                    text={Clause.text.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "")}
                  >
                    <div>
                      <button
                        className="copy-clause"
                        onClick={setCopied}
                        style={{ color: TextColor }}
                      >
                        <FontAwesomeIcon
                          icon={faCopy}
                          size="lg"
                          className="copy-icon mr-1"
                        />
                        {copyClause}
                      </button>
                    </div>
                  </CopyToClipboard>
                )}
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}

/*<button className="copy-clause">Copy Clause</button>

<>
                    <button>
                      <FontAwesomeIcon
                        icon={faCopy}
                        size="lg"
                        className="copy-icon"
                      />
                      &nbsp; <strong>Copy Clause</strong>
                    </button>
                    <button className="copy-clause">Copy Clause</button>
                  </>

*/
